import { useEffect, useState, useRef, forwardRef } from 'react'
import ReactDatePicker, { registerLocale } from 'react-datepicker'
import sv from 'date-fns/locale/sv'
import { isSameDay } from 'date-fns'
import { utcToZonedTime, zonedTimeToUtc, formatInTimeZone } from 'date-fns-tz'
import 'react-datepicker/dist/react-datepicker.css'
import * as styles from './index.module.css'
import i18next from '~/i18n'

const STOCKHOLM_TZ = 'Europe/Stockholm'
const toDisplay = date => utcToZonedTime(date, STOCKHOLM_TZ)
const toUtc = date => zonedTimeToUtc(date, STOCKHOLM_TZ)

registerLocale('sv', sv)

function CalendarIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M8.00009 2.75C8.23259 2.75 8.34883 2.75 8.44421 2.77556C8.70303 2.84491 8.90519 3.04707 8.97454 3.30588C9.00009 3.40126 9.00009 3.5175 9.00009 3.75L9.0001 3.875C9.0001 3.99149 9.0001 4.04973 9.01913 4.09567C9.0445 4.15693 9.09317 4.2056 9.15442 4.23097C9.20037 4.25 9.25861 4.25 9.3751 4.25H14.6251C14.7416 4.25 14.7998 4.25 14.8458 4.23097C14.907 4.2056 14.9557 4.15693 14.9811 4.09567C15.0001 4.04973 15.0001 3.99148 15.0001 3.875L15.0001 3.75C15.0001 3.51751 15.0001 3.40126 15.0256 3.30589C15.095 3.04707 15.2972 2.84491 15.556 2.77556C15.6514 2.75 15.7676 2.75 16.0001 2.75C16.2326 2.75 16.3488 2.75 16.4442 2.77556C16.703 2.84491 16.9052 3.04707 16.9745 3.30588C17.0001 3.40126 17.0001 3.5175 17.0001 3.75L17.0001 3.89042C17.0001 4.00817 17.0001 4.06704 17.0187 4.11248C17.0422 4.17002 17.0817 4.21291 17.1372 4.24099C17.1809 4.26316 17.2431 4.26821 17.3673 4.27829C17.6085 4.29787 17.8284 4.33084 18.0354 4.3863C19.4157 4.75617 20.4939 5.83436 20.8638 7.21472C21.0009 7.72638 21.0006 8.31704 21.0001 9.11242C21.0001 9.15761 21.0001 9.20347 21.0001 9.25V15.4913C21.0001 16.2963 21.0001 16.9606 20.9559 17.5018C20.91 18.0639 20.8114 18.5806 20.5641 19.066C20.1806 19.8186 19.5687 20.4305 18.8161 20.814C18.3307 21.0613 17.814 21.1599 17.2519 21.2058C16.7107 21.25 16.0464 21.25 15.2414 21.25H8.75877C7.95381 21.25 7.28946 21.25 6.74827 21.2058C6.18617 21.1599 5.66947 21.0613 5.18413 20.814C4.43149 20.4305 3.81956 19.8186 3.43607 19.066C3.18878 18.5806 3.09022 18.0639 3.04429 17.5018C3.00007 16.9606 3.00008 16.2963 3.0001 15.4913L3.0001 9.25C3.0001 9.20346 3.00007 9.15761 3.00005 9.11242C2.99962 8.31703 2.9993 7.72637 3.13639 7.21472C3.50626 5.83436 4.58445 4.75617 5.96482 4.3863C6.17179 4.33084 6.3917 4.29787 6.63285 4.27829C6.75712 4.26821 6.81925 4.26316 6.86304 4.24099C6.91848 4.21291 6.95804 4.17001 6.98154 4.11248C7.0001 4.06704 7.0001 4.00817 7.0001 3.89042L7.00009 3.75C7.00009 3.51751 7.00009 3.40126 7.02565 3.30589C7.095 3.04707 7.29716 2.84491 7.55598 2.77556C7.65135 2.75 7.7676 2.75 8.00009 2.75ZM8.0001 6.25C7.00574 6.25 6.70474 6.25859 6.48246 6.31815C5.79227 6.50308 5.25318 7.04218 5.06824 7.73236C5.01995 7.9126 5.00517 7.4871 5.00131 7.84983C4.99983 7.98846 4.99909 8.05778 5.02613 8.11183C5.04974 8.15905 5.08855 8.19827 5.13551 8.22239C5.18928 8.25 5.25955 8.25 5.4001 8.25H18.6001C18.7406 8.25 18.8109 8.25 18.8647 8.22239C18.9116 8.19827 18.9504 8.15905 18.9741 8.11183C19.0011 8.05778 19.0004 7.98846 18.9989 7.84983C18.995 7.4871 18.9802 7.9126 18.9319 7.73236C18.747 7.04218 18.2079 6.50308 17.5177 6.31815C17.2955 6.25859 16.9944 6.25 16.0001 6.25H8.0001ZM19.0001 10.65C19.0001 10.51 19.0001 10.44 18.9728 10.3865C18.9489 10.3395 18.9106 10.3012 18.8636 10.2772C18.8101 10.25 18.7401 10.25 18.6001 10.25H5.4001C5.26008 10.25 5.19008 10.25 5.1366 10.2772C5.08956 10.3012 5.05131 10.3395 5.02734 10.3865C5.0001 10.44 5.0001 10.51 5.0001 10.65V15.45C5.0001 16.3066 5.00087 16.8889 5.03765 17.339C5.07347 17.7774 5.13839 18.0016 5.21808 18.158C5.40983 18.5343 5.71579 18.8403 6.09212 19.032C6.24852 19.1117 6.47272 19.1766 6.91113 19.2124C7.36122 19.2492 7.94352 19.25 8.8001 19.25H15.2001C16.0567 19.25 16.639 19.2492 17.0891 19.2124C17.5275 19.1766 17.7517 19.1117 17.9081 19.032C18.2844 18.8403 18.5904 18.5343 18.7821 18.158C18.8618 18.0016 18.9267 17.7774 18.9625 17.339C18.9993 16.8889 19.0001 16.3066 19.0001 15.45V10.65Z" fill="#5D5D5F"/>
      <path d="M16.0001 17.25H15.0001C14.7676 17.25 14.6514 17.25 14.556 17.2244C14.2972 17.1551 14.095 16.9529 14.0256 16.6941C14.0001 16.5987 14.0001 16.4825 14.0001 16.25C14.0001 16.1055 14.0001 15.6199 14.0062 15.25C14.01 15.0245 14.016 14.842 14.0256 14.8059C14.095 14.5471 14.2972 14.3449 14.556 14.2756C14.6514 14.25 14.7676 14.25 15.0001 14.25H16.0001C16.2326 14.25 16.3488 14.25 16.4442 14.2756C16.703 14.3449 16.9052 14.5471 16.9745 14.8059C16.9842 14.842 16.9902 15.0245 16.994 15.25C17.0001 15.6199 17.0001 16.1055 17.0001 16.25C17.0001 16.4825 17.0001 16.5987 16.9745 16.6941C16.9052 16.9529 16.703 17.1551 16.4442 17.2244C16.3488 17.25 16.2326 17.25 16.0001 17.25Z" fill="#5D5D5F"/>
    </svg>
  )
}

function CalendarAirportIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 2.75C16.2325 2.75 16.349 2.74984 16.4443 2.77539C16.7031 2.84474 16.9052 3.04696 16.9746 3.30566C17.0002 3.40104 17 3.51751 17 3.75V3.89062C17 4.00807 17.0001 4.06691 17.0186 4.1123C17.042 4.16975 17.0814 4.21313 17.1367 4.24121C17.1805 4.26338 17.243 4.26824 17.3672 4.27832C17.6083 4.29789 17.8282 4.33128 18.0352 4.38672C19.4155 4.75659 20.4944 5.83448 20.8643 7.21484C21.0013 7.72642 21.0004 8.3171 21 9.1123V15.4912C21 16.2962 21.0003 16.9608 20.9561 17.502C20.9101 18.064 20.8117 18.5811 20.5645 19.0664C20.181 19.8189 19.5689 20.431 18.8164 20.8145C18.3311 21.0617 17.814 21.1601 17.252 21.2061C16.7108 21.2503 16.0462 21.25 15.2412 21.25H8.75879C7.95383 21.25 7.28924 21.2503 6.74805 21.2061C6.18623 21.1601 5.6697 21.0615 5.18457 20.8145C4.4321 20.4311 3.82003 19.8188 3.43652 19.0664C3.18925 18.5811 3.08987 18.064 3.04395 17.502C2.99973 16.9608 2.99999 16.2962 3 15.4912V9.1123C2.99957 8.31699 2.99964 7.72646 3.13672 7.21484C3.50658 5.8345 4.58452 4.75661 5.96484 4.38672C6.17181 4.33126 6.39167 4.2979 6.63281 4.27832C6.75708 4.26823 6.81949 4.26339 6.86328 4.24121C6.91867 4.21313 6.95796 4.1698 6.98145 4.1123C6.99995 4.06691 7 4.00813 7 3.89062V3.75C7 3.51751 6.99984 3.40104 7.02539 3.30566C7.09475 3.047 7.29701 2.84479 7.55566 2.77539C7.65103 2.74984 7.76757 2.75 8 2.75C8.23249 2.75 8.34896 2.74984 8.44434 2.77539C8.70305 2.84474 8.90522 3.04696 8.97461 3.30566C9.00016 3.40104 9 3.51751 9 3.75V3.875C9 3.99149 9.0005 4.04976 9.01953 4.0957C9.04492 4.15688 9.0931 4.2061 9.1543 4.23145C9.20022 4.25045 9.25863 4.25 9.375 4.25H14.625C14.7413 4.25 14.7998 4.25038 14.8457 4.23145C14.907 4.20607 14.9561 4.15696 14.9814 4.0957C15.0004 4.04978 15 3.9914 15 3.875V3.75C15 3.51751 14.9998 3.40104 15.0254 3.30566C15.0948 3.047 15.297 2.84479 15.5557 2.77539C15.651 2.74984 15.7676 2.75 16 2.75ZM8 6.25C7.00572 6.25 6.70469 6.2588 6.48242 6.31836C5.79228 6.50332 5.25329 7.04227 5.06836 7.73242C5.00881 7.9547 5 8.25569 5 9.25V15.4502C5 16.3066 5.00132 16.8888 5.03809 17.3389C5.07391 17.7773 5.13808 18.0018 5.21777 18.1582C5.40949 18.5344 5.71557 18.8405 6.0918 19.0322C6.2482 19.1119 6.47272 19.1771 6.91113 19.2129C7.36117 19.2497 7.94341 19.25 8.7998 19.25H15.2002C16.0566 19.25 16.6388 19.2496 17.0889 19.2129C17.5273 19.1771 17.7518 19.1119 17.9082 19.0322C18.2845 18.8405 18.5905 18.5345 18.7822 18.1582C18.8619 18.0018 18.9271 17.7773 18.9629 17.3389C18.9997 16.8888 19 16.3066 19 15.4502V9.25C19 8.25565 18.9912 7.9547 18.9316 7.73242C18.7467 7.04225 18.2078 6.50329 17.5176 6.31836C17.2953 6.25882 16.9942 6.25 16 6.25H8ZM14.0781 9.16699C14.4327 8.81242 14.9419 8.65851 15.4336 8.75684L15.5117 8.77246C15.7095 8.8121 15.8637 8.96723 15.9033 9.16504L15.9189 9.24316C16.0173 9.73491 15.8634 10.243 15.5088 10.5977L14.0137 12.0938L14.7451 15.3887C14.8667 15.9358 14.5124 16.4768 13.9629 16.5869C13.8525 16.609 13.74 16.5547 13.6895 16.4541L12.3438 13.7627L10.5557 15.3135L11.0703 16.6514C11.1164 16.7714 11.0641 16.9072 10.9492 16.9648L10.4219 17.2285C10.2984 17.2903 10.1477 17.2397 10.0859 17.1162L9.24414 15.4326L7.56055 14.5908C7.43705 14.5291 7.38649 14.3784 7.44824 14.2549L7.71191 13.7275C7.76953 13.6125 7.90529 13.5603 8.02539 13.6064L9.36328 14.1211L10.9131 12.332L8.22266 10.9873C8.1219 10.9369 8.06774 10.8244 8.08984 10.7139C8.19987 10.1643 8.7409 9.80909 9.28809 9.93066L12.583 10.6631L14.0781 9.16699Z" fill="#5D5D5F"/>
    </svg>
  )
}

// wasOpenRef and calendarOpen are passed through customInput JSX (not overridden by
// RDP's cloneElement which only injects onClick, value, ref).
// onMouseDown captures whether the calendar was open at mousedown time so that
// onInputClick can decide not to reopen it (toggle behaviour).
const DateTrigger = forwardRef(({ value, onClick, placeholder, wasOpenRef, calendarOpen, isAirport }, ref) => (
  <button
    type="button"
    className={styles.date}
    onMouseDown={() => { if (wasOpenRef) wasOpenRef.current = calendarOpen }}
    onClick={onClick}
    ref={ref}
  >
    <span className={styles.dateTriggerText}>{value || placeholder}</span>
    {isAirport ? <CalendarAirportIcon /> : <CalendarIcon />}
  </button>
))

function TimeInput({ value, min, max, onPendingChange, onCommit, onClose }) {
  const [localValue, setLocalValue] = useState(value)
  const isDirty = useRef(false)

  return (
    <div className={styles.timeInputRow}>
      <input
        type="time"
        className={styles.timeInput}
        value={isDirty.current ? localValue : value}
        min={min}
        max={max}
        onChange={e => {
          isDirty.current = true
          setLocalValue(e.target.value)
          onPendingChange(e.target.value)
        }}
        onBlur={() => {
          setTimeout(() => {
            isDirty.current = false
            onCommit()
          }, 0)
        }}
      />
      {onClose && (
        <button type="button" className={styles.calendarOkButton} onClick={onClose}>
          OK
        </button>
      )}
    </div>
  )
}

export default function DatePicker({ field, form: { setFieldValue }, minDate, maxDate, showTimeInput, isAirport, onInvalidTime }) {
  // selectedDate is always a Stockholm "display date": getHours() returns Stockholm hour
  const [selectedDate, setSelectedDate] = useState(toDisplay(field.value || minDate || new Date()))
  const [calendarOpen, setCalendarOpen] = useState(false)
  const pendingTime = useRef(null)
  const selectedDateRef = useRef(selectedDate)
  selectedDateRef.current = selectedDate
  const wasOpenRef = useRef(false)

  // setDate receives a real UTC Date, stores Stockholm display, writes UTC to Formik
  const setDate = utcDate => {
    const displayDate = toDisplay(utcDate)
    selectedDateRef.current = displayDate
    setSelectedDate(displayDate)
    setFieldValue(field.name, utcDate)
  }

  useEffect(() => {
    if (field.value) setSelectedDate(toDisplay(field.value))
  }, [field.value])

  // Convert min/max to Stockholm display for ReactDatePicker
  const displayMinDate = minDate ? toDisplay(minDate) : undefined
  const displayMaxDate = maxDate ? toDisplay(maxDate) : undefined

  const minTime = displayMinDate && selectedDate && isSameDay(selectedDate, displayMinDate)
    ? formatInTimeZone(minDate, STOCKHOLM_TZ, 'HH:mm')
    : undefined
  const maxTime = displayMaxDate && selectedDate && isSameDay(selectedDate, displayMaxDate)
    ? formatInTimeZone(maxDate, STOCKHOLM_TZ, 'HH:mm')
    : undefined

  const commitPending = () => {
    const t = pendingTime.current
    if (!t) return
    pendingTime.current = null
    const [h, m] = t.split(':').map(Number)
    // selectedDateRef.current is a Stockholm display Date; set Stockholm h:m on it
    const newDisplayDate = new Date(selectedDateRef.current)
    newDisplayDate.setHours(h, m, 0, 0)
    const newDate = toUtc(newDisplayDate)
    const clamped = minDate && newDate < minDate ? new Date(minDate)
                  : maxDate && newDate > maxDate ? new Date(maxDate)
                  : newDate
    if (clamped.getTime() !== newDate.getTime()) {
      setCalendarOpen(false)
      onInvalidTime?.()
    }
    setDate(clamped)
  }

  const commitRef = useRef(commitPending)
  commitRef.current = commitPending

  if (!showTimeInput) {
    return (
      <ReactDatePicker
        selected={selectedDate}
        minDate={displayMinDate}
        maxDate={displayMaxDate}
        onChange={date => {
          // date is a Stockholm display Date from ReactDatePicker
          const copy = new Date(date)
          if (pendingTime.current) {
            const [h, m] = pendingTime.current.split(':').map(Number)
            copy.setHours(h, m, 0, 0) // Stockholm h:m on Stockholm display Date
            pendingTime.current = null
            const utcDate = toUtc(copy)
            const clamped = minDate && utcDate < minDate ? new Date(minDate)
                          : maxDate && utcDate > maxDate ? new Date(maxDate)
                          : utcDate
            if (clamped.getTime() !== utcDate.getTime()) onInvalidTime?.()
            setDate(clamped)
          } else {
            copy.setHours(selectedDateRef.current.getHours(), selectedDateRef.current.getMinutes(), 0, 0)
            setDate(toUtc(copy))
          }
        }}
        locale={i18next.language}
        dateFormat="d MMMM yyyy, HH:mm"
        showTimeInput
        timeInputLabel=""
        customTimeInput={
          <TimeInput
            min={minTime}
            max={maxTime}
            onPendingChange={t => { pendingTime.current = t }}
            onCommit={() => commitRef.current()}
          />
        }
        inline
        fixedHeight
      />
    )
  }

  const closeCalendar = () => {
    setCalendarOpen(false)
    commitRef.current()
  }

  return (
    <ReactDatePicker
      open={calendarOpen}
      onInputClick={() => {
        if (!wasOpenRef.current) setCalendarOpen(true)
      }}
      onClickOutside={closeCalendar}
      onCalendarClose={closeCalendar}
      shouldCloseOnSelect={false}
      selected={selectedDate}
      minDate={displayMinDate}
      maxDate={displayMaxDate}
      onChange={date => setDate(toUtc(date))}
      locale={i18next.language}
      customInput={
        <DateTrigger
          placeholder={i18next.t('placeholder-pick-date')}
          wasOpenRef={wasOpenRef}
          calendarOpen={calendarOpen}
          isAirport={isAirport}
        />
      }
      dateFormat="d MMMM yyyy, HH:mm"
      showTimeInput
      timeInputLabel=""
      customTimeInput={
        <TimeInput
          min={minTime}
          max={maxTime}
          onPendingChange={t => { pendingTime.current = t }}
          onCommit={() => commitRef.current()}
          onClose={closeCalendar}
        />
      }
      portalId="datepicker-portal"
      fixedHeight
    />
  )
}
